// extracted by css-extract-rspack-plugin
export default {"helperText":"product-listing-fragment__HelperText_helperText__TEnmO","isError":"product-listing-fragment__HelperText_isError__rTgEZ"};